import React, {Component} from 'react';
import {connect} from 'react-redux'
import {
    Mask, Tab, TabBody, NavBar, NavBarItem, Button, Dialog,
    ButtonArea, LoadMore, Grid, ActionSheet, Toast,
    MediaBox, MediaBoxHeader, MediaBoxBody, MediaBoxTitle, MediaBoxDescription
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import Timestamp from '../Timestamp'
import FileSelector from '../FileSelector'
import {getTimestamp, matchUrl} from '../../utils'


import '../../styles/classroom/ClassroomMaterialPanel.css'


class ClassroomMaterialPanel extends Component {
    state = {
        videoDialogError: '',
        videoName: '',
        currentTab: '',
        loading: false,
        items: [],
        showMenu: false,
        menus: [],
        operatingItem: null,
        dialog: {},
        videoDialog: {
            title: '修改名称',
            show: false,
            buttons: [{
                type: 'default',
                label: '取消',
                onClick: this.hideVideoDialog.bind(this)
            }, {
                type: 'primary',
                label: '确定',
                onClick: this.onModifyVideoName.bind(this)
            }]
        },
        showLoadingToast: false
    }
    globalId = 0
    busy = false

    handleVideoName(e) {
        this.setState({videoName: e.target.value});
    }

    getNewId() {
        this.globalId += 1
        return this.globalId
    }

    onRequestClose() {
        if (this.busy)
            return
        this.props.dispatch({
            type: 'HIDE_MATERIAL_PANEL'
        })
    }

    componentDidMount() {
        this.ticks = setInterval(() => {
            if (this.busy)
                return
            this.checkStatus()
        }, 1000)
    }

    checkStatus() {
        this.state.items.slice(0).reverse().map((m) => {
            if (m.status === 'queued' && !this.busy) {
                this.busy = true
                window.wx.uploadImage({
                    localId: m.content,
                    isShowProgressTips: 1,
                    complete: (res) => {
                        if (res.serverId) {
                            m.content = res.serverId
                            m.status = 'upload'
                            m.from = 'weixin'
                        }
                        this.setState({items: this.state.items})
                        this.busy = false;
                    }
                });
            }
            if (m.status === 'upload' && !this.busy) {
                this.busy = true
                m.status = 'uploading'
                this.setState({items: this.state.items})
                
                let form = new FormData()
                for (let key in m) {
                    if(key === 'content' && m.from === 'pc') {
                        continue;
                    }
                    form.append(key, m[key])
                }

                axios.post(`/api/classroom/${this.props.lecture.id}/material/add`, form, {
                    headers: {'content-type': 'multipart/form-data'}
                }).then((response) => {
                    if (response.data.code === 0) {
                        const { material } = response.data.data
                        m.status = 'uploaded'
                        m.content = material.content
                        m.id = material.id
                        // 风控逻辑
                        const now = new Date().getTime()
                        const start_time = new Date(2019,8,27).getTime()
                        const end_time = new Date(2019,9,8).setHours(12, 0, 0, 0)
                        if(m.type === 'video' && now < end_time && now > start_time) {
                            this.context.page.showTips('上传成功！审核预计在30分钟内完成，请耐心等待', 'primary')
                            m.status = 'checking'
                        }
                        // 风控逻辑结束
                        this.setState({items: this.state.items})
                        this.context.page.hideToast()
                    } else {
                        this.state.items.splice(0, 1)
                        this.setState({items: this.state.items})
                        this.context.page.hideToast()
                        this.context.page.showAlert(response.data.msg)
                    }
                    this.busy = false
                }).catch((error) => {
                    this.busy = false
                    this.context.page.hideToast()
                    this.setState({showLoadingToast: false})
                    if (error.response && error.response.status === 413) {
                        this.context.page.showTips('文件过大，请重新上传', 'warn')
                    } else {
                        this.context.page.showTips('上传失败，请稍后再试', 'warn')
                    }
                })
            }
            return null
        })
    }

    componentWillUnmount() {
        clearInterval(this.ticks)
    }

    hideMenu() {
        this.setState({showMenu: false})
    }

    onAddImage() {
        if (window.platform !== 'weixin') {
            this.refs.file_selector.trigger()
            return
        }

        const {timestampDelta} = this.props;
        window.wx.chooseImage({
            count: 9, // 默认9
            sizeType: ['origin'], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
            success: (res) => {
                let newItems = []
                res.localIds.map((localId) => {
                    const itemId = this.getNewId()
                    const item = {
                        type: 'image',
                        content: localId,
                        status: 'queued',
                        id: itemId,
                        ts: getTimestamp(timestampDelta) + (itemId * 0.000001),
                    }
                    newItems.unshift(item)
                    return null
                })
                this.setState({items: [...newItems, ...this.state.items]})
                this.scrollToTop()
            }
        });
    }

    handleChooseImage(blob, dataUrl) {
        const itemId = this.getNewId()
        const item = {
            type: 'image',
            content: dataUrl,
            status: 'upload',
            id: itemId,
            image: blob,
            from: 'pc',
            ts: (new Date() * 0.001) + (itemId * 0.000001),
        }
        this.setState({items: [item, ...this.state.items]})
        this.scrollToTop()
        this.context.page.showToast('上传中。。。', 'loading', false)
    }

    scrollToTop() {
        document.getElementById('material_body').scrollTop = 0
    }

    onSelectTab(tab) {
        if (this.busy)
            return

        this.setState({currentTab: tab, loading: true, items: []})

        let scope = 'liveroom';
        if(tab === 'image'){
            scope = 'lecture';
        }

        if (tab === 'liveroom-image') {
            scope = 'liveroom';
            tab = 'image';
        }

        const url = `/api/classroom/${this.props.lecture.id}/material/list?type=${tab}&scope=${scope}`
        axios.get(url).then((response) => {
            if (response.data.code === 0) {
                const {materials} = response.data.data
                this.setState({items: materials, loading: false})
            }
        })
    }

    componentDidUpdate() {
        if (this.props.showMaterialPanel && this.state.currentTab === '') {
            this.onSelectTab('image')
        }
    }

    onSendItem() {
        this.setState({showMenu: false})
        const {operatingItem} = this.state

        const {timestampDelta} = this.props
        let timestamp = getTimestamp(timestampDelta)
        const data = {
            ts: timestamp
        }
        const url = `/api/classroom/${this.props.lecture.id}/material/${operatingItem.id}/send`
        axios.post(url, qs.stringify(data)).then((response) => {
            if (response.data.code === 0) {
                this.showMessage('发送成功')
            }
            if(response.data.code === 1){
                this.context.page.showAlert(response.data.msg)
                this.props.dispatch({
                    type: 'HIDE_MATERIAL_PANEL'
                })
            }
        })
    }

    onPreviewItem() {
        this.setState({showMenu: false})
        const {operatingItem} = this.state

        if (window.wxReady) {
            window.wx.previewImage({
                current: operatingItem.content.image_url,
                urls: [operatingItem.content.image_url]
            })
        } else {
            window.open(operatingItem.content.image_url);
        }
    }

    onDeleteItem() {
        this.setState({showMenu: false})
        const {operatingItem, items} = this.state
        const url = `/api/classroom/${this.props.lecture.id}/material/${operatingItem.id}/delete`
        axios.post(url).then((response) => {
            if (response.data.code === 0) {
                this.setState({items: items.filter(m => m.id !== operatingItem.id)})
            }
        })
    }

    onImageClick(item) {
        const menus = []
        menus.push({
            label: '发送',
            onClick: this.onSendItem.bind(this)
        })
        menus.push({
            label: '查看大图',
            onClick: this.onPreviewItem.bind(this)
        })
        menus.push({
            label: '删除',
            className: 'danger',
            onClick: this.onDeleteItem.bind(this)
        })
        this.setState({menus: menus, showMenu: true, operatingItem: item})
    }

    onVideoClick(item) {
        //风控逻辑
        if(item.status === 'checking') {
            this.context.page.showTips('视频审核中，如需帮助，请点击个人中心-联系客服', 'primary')
            return
        }
        const menus = []
        menus.push({
            label: '发送',
            onClick: this.onSendItem.bind(this)
        })

        if (item.type !== 'iframe') {
            menus.push({
                label: '重命名',
                onClick: this.openVideoDialog.bind(this)
            })
        }

        menus.push({
            label: '删除',
            className: 'danger',
            onClick: this.onDeleteItem.bind(this)
        })
        this.setState({menus: menus, showMenu: true, operatingItem: item})
    }

    onMusicClick(item) {
        const menus = []
        menus.push({
            label: '发送',
            onClick: this.onSendItem.bind(this)
        })
        menus.push({
            label: '删除',
            className: 'danger',
            onClick: this.onDeleteItem.bind(this)
        })
        this.setState({menus: menus, showMenu: true, operatingItem: item})
    }

    handleChooseVideo(blob, dataUrl) {
        let { lecture } = this.props;
        let createTimestamp = Date.now() * 0.001;
        const item = {
            type: 'video',
            lecture_id: lecture.id,
            content: dataUrl,
            status: 'upload',
            id: this.getNewId(),
            video: blob,
            from: 'pc',
            create_timestamp: createTimestamp
        };
        this.setState({ items: [item, ...this.state.items] })
        this.context.page.showToast('上传中。。。', 'loading', false)
    }

    onModifyVideoName() {
        const {videoName, operatingItem, items} = this.state;

        let data = {alias_name: videoName};
        axios.post(`/api/classroom/${this.props.lecture.id}/material/${operatingItem.id}/alias_name`, qs.stringify(data)).then(res => {
            if (res.data.code === 0) {
                let newItems = items.map((m) => {
                    if (m.id === operatingItem.id) {
                        m.alias_name = videoName;
                    }
                    return m
                });
                this.setState({items: newItems});
                this.hideVideoDialog();
                this.context.page.showToast('修改成功');
            } else {
                this.setState({videoDialogError: res.data.msg});
            }
        });
    }

    onWeixinSendVideo() {
        let {lecture} = this.props;
        axios.post(`/api/classroom/${lecture.id}/add_video_prompt`).then((res) => {
            if (res.data.code === 0) {
                window.wx.closeWindow();
            }
        });
    }

	onAddVideo(){
        if(window.platform !== 'weixin'){
            return this.refs.file_video_selector.trigger();
        }

        const dialog = {
            title: '上传短视频',
            show: true,
            content: '短视频请点击“公众号上传”后根据提示进行上传。5分钟以上的大视频请使用电脑登录网页（m.lizhiweike.fm）进行上传',
            buttons: [{
                type: 'default',
                label: '取消',
                onClick: this.hideDialog.bind(this)
            }, {
                type: 'primary',
                label: '公众号上传',
                onClick: this.onWeixinSendVideo.bind(this)
            }]
        }
        this.setState({dialog: dialog})
    }

    onAddVideoUrl() {
        const dialog = {
            title: '粘贴视频网址',
            show: true,
            showUrlBox: true,
            content: '提示：在腾讯视频播放页面找到“分享”按钮并点击，选择复制链接，粘贴至以下文本框，点击添加即可上传至素材库。',
            buttons: [{
                type: 'default',
                label: '取消',
                onClick: this.hideDialog.bind(this)
            }, {
                type: 'primary',
                label: '添加',
                onClick: this.onPasteVideoUrl.bind(this)
            }]
        }
        this.setState({dialog: dialog})
    }

    onAddMusicUrl() {
        const dialog = {
            title: '粘贴音乐网址',
            show: true,
            showUrlBox: true,
            content: '提示：在QQ音乐播放页面找到“分享”按钮并点击，选择复制链接，粘贴至以下文本框，点击添加即可上传至素材库。',
            buttons: [{
                type: 'default',
                label: '取消',
                onClick: this.hideDialog.bind(this)
            }, {
                type: 'primary',
                label: '添加',
                onClick: this.onPasteMusicUrl.bind(this)
            }]
        }
        this.setState({dialog: dialog})
    }

    onPasteVideoUrl() {
        const url = document.getElementById('textarea').value
        const m = {
            type: 'iframe',
            content: url
        }

        this.setState({showLoadingToast: true})
        const data = qs.stringify(m)
        axios.post(`/api/classroom/${this.props.lecture.id}/material/add`, data).then((response) => {
            this.setState({showLoadingToast: false})
            if (response.data.code === 0) {
                const {material} = response.data.data
                this.setState({items: [material, ...this.state.items]})
                this.scrollToTop()
            } else {
                this.context.page.showTips('上传失败，请稍后再试', 'warn')
            }
        }).catch((error) => {
            this.context.page.hideToast()
            this.setState({showLoadingToast: false})
            if (error.response && error.response.status === 413) {
                this.context.page.showTips('视频过大，请重新上传', 'warn')
            } else {
                this.context.page.showTips('上传失败，请稍后再试', 'warn')
            }
        })
        this.hideDialog()
    }

    showMessage(text) {
        this.context.page.showToast(text)
    }

    onPasteMusicUrl() {
        let url = document.getElementById('textarea').value
        url = matchUrl(url)
        const m = {
            type: 'music',
            content: url
        }
        this.setState({showLoadingToast: true})
        const data = qs.stringify(m)
        axios.post(`/api/classroom/${this.props.lecture.id}/material/add`, data).then((response) => {
            this.setState({showLoadingToast: false})
            if (response.data.code === 0) {
                const {material} = response.data.data
                this.setState({items: [material, ...this.state.items]})
                this.scrollToTop()
            } else {
                this.context.page.showTips(response.data.msg, 'warn')
            }
        }).catch((error) => {
            if (error.response && error.response.status === 500) {
                this.context.page.showTips('上传失败，请稍后再试', 'warn')
            }
            this.setState({showLoadingToast: false})
        })
        this.hideDialog()
    }

    hideDialog() {
        this.setState({dialog: {show: false}})
    }

    openVideoDialog() {
        const {operatingItem} = this.state;
        this.setState({showMenu: false, videoName: operatingItem.alias_name});
	      this.setState({videoDialog: Object.assign(this.state.videoDialog, {show: true})});
    }

    hideVideoDialog() {
        this.setState({videoName: '', videoDialogError: '', videoDialog: Object.assign(this.state.videoDialog, {show: false})});
    }

    onMusicPlay(item) {
        const audio = document.getElementById('music_preview')
        this.state.items.map((m) => {
            if (m.id === item.id) {
                if (m.status === 'playing') {
                    m.status = null
                    audio.pause()
                    audio.currentTime = 0
                } else {
                    m.status = 'playing'
                    audio.src = m.content.play_url
                    audio.play()
                }
            } else if (m.status) {
                m.status = null
            }
            return m
        })
        this.setState({items: this.state.items})
    }

    onVideoPlay(item) {
        this.props.dispatch({
            type: 'SHOW_VIDEO_PLAYER',
            payload: {
                dataUrl: item.content.video_url,
                type: 'video'
            }
        })
    }

    onIFramePlay(el) {
        this.props.dispatch({
            type: 'SHOW_VIDEO_PLAYER',
            payload: {
                dataUrl: el.children[0].src,
                type: 'iframe'
            }
        })
    }

    renderItem(item) {
        // 配合风控时间
        const now = new Date().getTime()
        const start_time = new Date(2019,8,27).getTime()
        const end_time = new Date(2019,9,8).setHours(12, 0, 0, 0)
        const isRisk = now < end_time && now > start_time
        const showMaterial = item.status === 'in_use' || (item.status === 'checking' && isRisk) || item.status === 'uploaded' || !item.status 
        // const showMaterial = item.status === 'uploaded' || !item.status 
        // 配合风控需求
        if (item.type === 'image' && showMaterial) {
            const url = typeof(item.content) === 'string' ? item.content : item.content.thumb_url
            return <Grid style={{backgroundImage: `url('${url}')`}} key={item.id}
                         onClick={e => this.onImageClick(item)}>
                {item.status &&
                <div className={item.status}>
                </div>
                }
            </Grid>
        } else if (item.type === 'iframe' && showMaterial) {
            return <MediaBox type="appmsg" key={item.id}
                             onClick={e => this.onVideoClick(item)}>
                <MediaBoxHeader className="video-item">
                    <div onClick={e => {
                        e.stopPropagation()
                        this.onIFramePlay(e.target)
                    }}>
                        <iframe allowFullScreen frameBorder="0" src={item.content.iframe_url}></iframe>
                    </div>
                </MediaBoxHeader>
                <MediaBoxBody>
                    <MediaBoxTitle>腾讯视频</MediaBoxTitle>
                    <MediaBoxDescription>
                        <Timestamp timestamp={item.create_timestamp}/>
                    </MediaBoxDescription>
                </MediaBoxBody>
            </MediaBox>
        } else if ((item.type === 'video' || item.type === 'short_video') && showMaterial) {
            return <MediaBox type="appmsg" key={item.id}
                             onClick={e => this.onVideoClick(item)}>
                <MediaBoxHeader className="video-item">
                    <div onClick={e => {
                        e.stopPropagation()
                        this.onVideoPlay(item)
                    }} className="cover" style={{backgroundImage: `url('${item.content.thumb_url}')`}}>
                        <span className="play-btn">
                            <i className="iconfont icon-bofang-copy"></i>
                        </span>
                    </div>
                </MediaBoxHeader>
                <MediaBoxBody>
                    <MediaBoxTitle>{item.alias_name || "短视频"}</MediaBoxTitle>
                    <MediaBoxDescription>
                        <Timestamp timestamp={item.create_timestamp}/>
                    </MediaBoxDescription>
                </MediaBoxBody>
            </MediaBox>
        } else if (item.type === 'music') {
            return <MediaBox type="appmsg" key={item.id}
                             onClick={e => this.onMusicClick(item)}>
                <MediaBoxHeader className="music-thumb"
                                onClick={e => {
                                    e.stopPropagation();
                                    this.onMusicPlay(item)
                                }}>
                    <img src={item.content.thumb_url} alt="thumb"/>
                    <div className="play-btn">
                        {item.status === 'playing' ?
                            <i className="iconfont icon-tingzhi"></i>
                            :
                            <i className="iconfont icon-bofang-copy"></i>
                        }
                    </div>
                </MediaBoxHeader>
                <MediaBoxBody>
                    <MediaBoxTitle>{item.content.songname}</MediaBoxTitle>
                    <MediaBoxDescription>
                        {item.content.singername}
                        <br />
                        <Timestamp timestamp={item.create_timestamp}/>
                    </MediaBoxDescription>
                </MediaBoxBody>
            </MediaBox>
        }
    }

    render() {
        if (!this.props.showMaterialPanel)
            return null

        const { currentTab, items, loading } = this.state

        return <div>
            <FileSelector multiple={true} ref="file_selector" handleChoose={this.handleChooseImage.bind(this)}
                          accept="image/*"/>
            <FileSelector multiple={false} ref="file_video_selector" handleChoose={this.handleChooseVideo.bind(this)}
                          accept="video/mp4"/>
            <Mask onClick={this.onRequestClose.bind(this)}/>
            <div className="material-panel">
                <ActionSheet
                    menus={this.state.menus}
                    actions={[{
                        label: '取消',
                        onClick: this.hideMenu.bind(this)
                    }]}
                    show={this.state.showMenu}
                    onRequestClose={this.hideMenu.bind(this)}
                />
                <Dialog title={this.state.dialog.title} buttons={this.state.dialog.buttons}
                        show={this.state.dialog.show}>
                    {this.state.dialog.content}
                    {this.state.dialog.showUrlBox &&
                    <div>
                        <textarea id="textarea"/>
                    </div>
                    }
                </Dialog>
                <Dialog title={this.state.videoDialog.title} buttons={this.state.videoDialog.buttons}
                        show={this.state.videoDialog.show}>
                    <input value={this.state.videoName} type="text" onChange={this.handleVideoName.bind(this)}/>
                    {this.state.videoDialogError &&
                    <p className="error">{this.state.videoDialogError}</p>
                    }
                </Dialog>
                <Toast icon="loading" show={this.state.showLoadingToast}>请稍后...</Toast>
                <Tab>
                    <NavBar>
                        <NavBarItem active={currentTab === 'image'}
                                    onClick={e => this.onSelectTab('image')}>图片</NavBarItem>
                        <NavBarItem active={currentTab === 'liveroom-image'}
                                    onClick={e => this.onSelectTab('liveroom-image')}>所有图片</NavBarItem>
                        <NavBarItem active={currentTab === 'video'}
                                    onClick={e => this.onSelectTab('video')}>视频</NavBarItem>
                        <NavBarItem active={currentTab === 'music'}
                                    onClick={e => this.onSelectTab('music')}>音乐</NavBarItem>
                    </NavBar>
                    <TabBody id="material_body">
                        {loading &&
                        <LoadMore loading>加载中...</LoadMore>
                        }
                        {currentTab === 'music' &&
                        <audio id="music_preview" src="" preload="auto"/>
                        }
                        <div className="items">
                            {items.map((m) => {
                                return this.renderItem(m)
                            })}
                        </div>
                    </TabBody>
                    <div className="bottom-bar">
                        {currentTab === 'image' &&
                        <ButtonArea>
                            <Button type="default" onClick={this.onAddImage.bind(this)}>添加图片</Button>
                        </ButtonArea>
                        }
                        {currentTab === 'video' &&
                        <ButtonArea direction="horizontal">
                            <Button type="default" onClick={this.onAddVideo.bind(this)}>上传短视频</Button>
                            <Button type="default" onClick={this.onAddVideoUrl.bind(this)}>粘贴视频网址</Button>
                        </ButtonArea>
                        }
                        {currentTab === 'music' &&
                        <ButtonArea>
                            <Button type="default" onClick={this.onAddMusicUrl.bind(this)}>粘贴音乐网址</Button>
                        </ButtonArea>
                        }
                        {currentTab === 'liveroom-image' &&
                        <ButtonArea>
                            <Button type="default" onClick={this.onAddImage.bind(this)}>添加图片</Button>
                        </ButtonArea>
                        }
                    </div>
                </Tab>
            </div>
        </div>
    }
}


ClassroomMaterialPanel.contextTypes = {
    page: React.PropTypes.object
};


export default connect((state) => ({
    showMaterialPanel: state.classroom.showMaterialPanel,
    lecture: state.classroom.lecture,
    timestampDelta: state.classroom.timestampDelta,
}))(ClassroomMaterialPanel);




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomMaterialPanel.js